module.exports = __webpack_public_path__ + "img/Vulpecula.778716b0.png";